module.exports = __webpack_public_path__ + "static/media/corporate.e878040f.png";